<template lang="pug">
  div.h-100
    app-header(title='Register', :progressCurrent="slideIndex", :progressMax="slideCount", @backSignal="goBack")
    transition(name="down", mode="out-in")
      div.wizard-body.bg-alt.h-100(v-if='showWizard')
        .container.h-100.pt-4
          b-carousel.h-100(id="carouselWizard", ref='carouselWizard', :no-touch="true", :interval="0", v-model="slideIndex")
            b-carousel-slide
              template(v-slot:img="")
                .container
                  b-form(v-on:submit.prevent='onSubmit()')
                    b-form-group(label="FIRST NAME")
                        b-form-input(name='given-name', type='text', v-model='inputForm.firstname', required='',  autocomplete="given-name")
                    b-form-group(label="LAST NAME")
                        b-form-input(name='family-name', type='text', v-model='inputForm.lastname', required='',  autocomplete="family-name")
                    b-form-group(label="EMAIL")
                      b-form-input(type='email', v-model='inputForm.email', required='',  autocomplete="email")
                    b-form-group(label="PHONE")
                      b-form-input(type='tel', v-model='inputForm.phone', required='', pattern="\\d{10}", title='10 Digits only. No +27 or spaces please :)',  autocomplete="tel")
                    b-button(type='submit', v-show="false", ref='submit0')
            b-carousel-slide
              template(v-slot:img="")
                b-form(v-on:submit.prevent='onSubmit()')
                  .container
                    b-form-group(label="PASSWORD")
                      b-form-input(type="password", name="password", v-model="inputForm.password", required="", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
                    p Password must be at least 8 characters, with a number and an uppercase letter.
                    b-form-group(label="CONFIRM PASSWORD")
                      b-form-input(type="password", name="password2", v-model="passwordRepeat", required="", pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
                    //- b-form-group(label="PASSWORD")
                    //-   b-form-input(type="password", name="password", v-model="inputForm.password", required="")
                    //- b-form-group(label="REPEAT")
                    //-   b-form-input(type="password", name="password", v-model="passwordRepeat", required="")
                    b-form-group
                      b-form-checkbox(v-model='aggree', switch)
                        span(href="") I agree to the Wall Collective
                        b-link.text-muted.mx-2(:to="{name: 'legal'}") General Terms and Conditions,
                        span and
                        b-link.text-muted.mx-2(:to="{name: 'legal'}") Privacy Policy
                  b-button(type='submit', v-show="false", ref='submit1')
            b-carousel-slide
              template(v-slot:img="")
                .container.pt-5.text-center
                  b-spinner(type="grow")
                  p.pt-5 CREATING ACCOUNT
    b-button#btn-bar(type='submit', :disabled="slideIndex == slideCount", @click="$refs[`submit${slideIndex}`].click()")
      span.m-0.text-light(v-if="slideIndex >= (slideCount-1)") REGISTER
      span.m-0.text-light(v-else="") NEXT
</template>

<script>

// import Vue from 'vue';
import { mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'formWizard',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      showWizard: false,
      inApartment: false,
      aggree: false,
      passwordRepeat: '',
      slideIndex: 0,
      slideCount: 2,
      inputForm: {
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        password: '',
        role: 'customer',
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('account', ['register']),
    onSubmit() {
      this.$refs.carouselWizard.next();
      if (this.slideIndex === this.slideCount - 1) {
        if (!this.inputForm.password || this.inputForm.password !== this.passwordRepeat) {
          this.goBack();
          this.error('Passwords do not match');
        } else if (!this.aggree) {
          this.goBack();
          this.error('Please agree to our terms and conditions first');
        } else {
          try {
            this.busy();
            this.register(this.inputForm);
          } catch (error) {
            this.error(error);
          }
        }
      }
    },
    goBack() {
      if (this.slideIndex > 0) {
        this.$refs.carouselWizard.prev();
      }
    },
  },
  created() {
    this.slideIndex = 0;
  },
  mounted() {
    // Create animation effect
    setTimeout(() => { this.showWizard = true; }, 100);
  },
};
</script>

<style lang="scss" scoped>
.wizard-body {
  z-index: 1000;
  background-color: white;
  // border-radius: 15px 15px 0 0;
  overflow-y: scroll;
}
  .carousel-indicators > li {
    background-color: blue !important;
  }

  .down-enter-active, .page-leave-active {
    transition: transform 0.5s;
  }
  .down-enter {
    transform: translateY(100%);
  }
  .logo {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Register.vue